export const WORKSPACE_ID = 1;
export const PROJECT_ID = 1;
export const PER_PAGE = 10;
export const PER_GROUP_PAGE = 10;
export const DEFAULT_GROUP_VALUE = 'Все';